
import Sidebar from './components/Sidebar';
import DashboardHeader from './components/DashboardHeader';
import QuickStats from './components/QuickStats';
import ProjectsOverview from './components/ProjectsOverview';
import CalendarWidget from './components/CalendarWidget';
import RecentActivity from './components/RecentActivity';

const Dashboard = () => {
  return (
    <div className="h-screen bg-gray-50 flex overflow-hidden">
      <Sidebar />
      
      <div className="flex-1 flex flex-col overflow-hidden">
        <DashboardHeader />
        
        <main className="flex-1 p-6 overflow-auto">
          <div className="mb-6">
            <h1 className="text-3xl font-bold text-gray-900 mb-2">Dashboard</h1>
            <p className="text-gray-600">Welcome back! Here's what's happening with your projects.</p>
          </div>

          <div className="mb-8">
            <QuickStats />
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
            <div className="lg:col-span-2">
              <ProjectsOverview />
            </div>
            
            <div className="space-y-6">
              <CalendarWidget />
              <RecentActivity />
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default Dashboard;
